import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { State } from '@vallift/ngl';
import { BaseComponent } from '@core/base/base-component';
import { MyFormsAPIService } from '@core/api/my-forms/services/my-forms-api/myFormsAPI.service';
import { RespondentTokenStorageService } from '@core/services/respondent-token-storage.service';
import type { MyFormsAuthApiResponse } from '@core/api/my-forms/models';
import { safeMyFormsReturnUrl } from '../../utils/safe-return-url';

@Component({
  selector: 'app-my-forms-google-success-page',
  imports: [RouterLink],
  template: `
    <div class="flex min-h-screen items-center justify-center bg-white px-4 font-inter">
      <div class="w-full max-w-md text-center">
        <h1 class="text-h4 text-slate-950">Signing you in…</h1>
        <p class="mt-2 text-body2 text-slate-500">
          Completing Google sign-in for My Forms.
        </p>
        <a routerLink="/my-forms" class="mt-6 inline-block text-body2 text-primary-600">
          Back to My Forms
        </a>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyFormsGoogleSuccessPage extends BaseComponent implements OnInit {
  private readonly myFormsApi = inject(MyFormsAPIService);
  private readonly respondentTokenStorage = inject(RespondentTokenStorageService);
  readonly authState = new State<MyFormsAuthApiResponse>();

  ngOnInit(): void {
    const ticket = this.route.snapshot.queryParamMap.get('ticket');
    if (!ticket) {
      void this.router.navigate(['/auth/my-forms/google/error'], {
        queryParams: { code: 'missing_ticket' },
      });
      return;
    }

    this.executeRequest({
      state: this.authState,
      request: this.myFormsApi.exchangeMyFormsTicket({ ticket }),
      showLoader: true,
      handleError: true,
      errorMessage: 'Google sign-in failed',
      onSuccess: (response) => {
        this.respondentTokenStorage.setSession(response.data);
        const returnUrl =
          safeMyFormsReturnUrl(
            this.route.snapshot.queryParamMap.get('returnUrl'),
          ) ?? '/my-forms/inbox';
        void this.router.navigateByUrl(returnUrl);
      },
      onFailed: () => {
        void this.router.navigate(['/auth/my-forms/google/error'], {
          queryParams: { code: 'exchange_failed' },
        });
      },
    });
  }
}
